export default class ToastMessages {
  //Success
  static readonly CREATED = "Created successfully";
  static readonly DELETED = "Deleted successfully";
  static readonly UPDATED = "Updated successfully";
  static readonly FILE_UPLOADED = "File uploaded successfully";
  static readonly REQUEST_SENT = "Request quote sent successfully";
  static readonly APPOINTMENT_CREATED = "Appointment created successfully";
  static readonly USER_CREATED = "User created successfully";
  static readonly EMAIL_SENT = "Email sent successfully";
  static readonly REVIEW_CREATED = "Review created successfully";
  static readonly APPOINTMENT_SENT = "Appointment request sent successfully";
  static readonly MESSAGE_SENT = "Message sent successfully";
  static readonly ADDED_TO_CALENDAR = "Event added to calendar";
  static readonly LOGGED_IN = "Logged in successfully, Welcome!";
  static readonly CLIENT_CREATED = "Client created successfully";
  static readonly USER_DELETED = "User deleted successfully";
  static readonly USER_UPDATED = "User updated successfully";
  static readonly USER_PASSWORD_UPDATED = "User password updated successfully";
  static readonly IMAGES_UPLOADED = "Images uploaded successfully";
  static readonly IMAGES_DELETED = "Images deleted successfully";
  static readonly IMAGES_UPDATED = "Images updated successfully";
  static readonly PASSWORD_UPDATED = "Password updated successfully";
  static readonly ACCOUNT_ACTIVATED = "Account activated successfully";
  static readonly ACCOUNT_DELETED = "Account deleted successfully";
  static readonly ESTIMATE_STATUS_UPDATED =
    "Estimate status updated successfully";
  static readonly SMS_SENT = "SMS notification sent successfully";
  static readonly EMAIL_SENT_TO_CLIENT = "Email sent to client successfully";

  //Error
  static readonly CREATE_FAILED = "Insert failed";
  static readonly DELETE_FAILED = "Delete failed";
  static readonly UPDATE_FAILED = "Update failed";
  static readonly UPLOAD_FAILED = "Failed to upload file";
  static readonly READ_FAILED = "Cannot get items";
  static readonly REQUEST_FAILED = "Error sending request quote!";
  static readonly APPOINTMENT_FAILED = "Error creating appointment!";
  static readonly APPOINTMENT_UPDATE_FAILED = "Error updating appointment!";
  static readonly EMAIL_FAILED = "Failed to send email";
  static readonly APPOINTMENT_FAILED_TO_SEND =
    "Error sending appointment request!";
  static readonly MESSAGE_FAILED_TO_SEND = "Error sending message!";
  static readonly CLIENT_FAILED = "Failed to create client";
  static readonly GOOGLE_CALENDAR_FAILED =
    "Failed to add event to calendar, please login again";
  static readonly LOGIN_FAILED = "Username or password invalid";
  static readonly FETCH_FAILED = "Failed to fetch data";
  static readonly IMAGES_FAILED = "Failed to fetch images";
  static readonly IMAGES_ERROR_FIREBASE = "Error uploading images to Firebase";
  static readonly IMAGES_ERROR_SERVER = "Error uploading images to server";
  static readonly IMAGES_ERROR_DELETING = "Error deleting images.";
  static readonly PASSWORD_CHANGE_FAILED = "Failed to change password";
  static readonly FIREBASE_ERROR = "Firebase error";
  static readonly FIREBASE_FILE__UPLOAD_ERROR =
    "Error uploading file to Firebase";
  static readonly FIREBASE_FILE__DELETE_ERROR =
    "Error deleting file to Firebase";
  static readonly ESTIMATE_STATUS_FAILED = "Error updating estimate status";
  static readonly GOOGLE_CALENDAR_EXPIRED =
    "Google Calendar session expired, please login again";
  static readonly UNAUTHORIZED =
    "You are not authorized to perform this action";
  static readonly PERMISSIONS_UPDATE_FAILED = "Failed to update permissions";
  static readonly SMS_NOT_SENT = "SMS not sent";
  static readonly EMAIL_NOT_SENT_TO_CLIENT = "Email not sent to client";
  static readonly USER_PASSWORD_UPDATE_FAILED =
    "Failed to update user password";
  static readonly INVALID_PASSWORD_FORMAT = "Invalid password format";
  static readonly FAILED_TO_RESEND_ACTIVATION_CODE =
    "Failed to resend activation code";
  static readonly GENERIC_ERROR = "An error occurred, please try again";
  static readonly PASSWORDS_DO_NOT_MATCH =
    "New password and confirm password do not match";

  //Warning
  static readonly SELECT_FILE = "Please select a file";
  static readonly INVALID_LOGIN_FORM = "Please fill in the form correctly";

  //Info
  static readonly MISSING_INFO = "Missing some informations";
  static readonly NO_CHANGES = "No changes to save";
  static readonly NO_ITEMS = "No items found";
  static readonly NO_IMAGES = "No images found";
  static readonly NO_SERVICES = "No services found";
  static readonly MAX_IMAGES_UPLOAD = "You can only upload up to 20 files.";
  static readonly PASSWORDS_EQUAL =
    "New password must be different from the old one";
  static readonly ACCOUNT_ALREADY_ACTIVATED =
    "Account is already activated, please login.";
}
